import { IRejectValueThunkConfig } from '@/Interfaces/Slices/AsyncThunk.interface';
import { SupportRequestPayload } from '@/types/support.types';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { sendSupportRequest } from '../api/support.api';
import { pendingCaseHandler, rejectedCaseHandler } from '../asyncThunkHandlers';

enum actionPrefix {
  REQUEST = 'supportSlice/request',
}

interface IState {
  supportRequestId: null | string;
}

const initialState: IState = {
  supportRequestId: null,
};

const supportSlice = createSlice({
  name: 'support',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(sendRequest.fulfilled, state => {
        state.supportRequestId = null;
      })
      .addCase(sendRequest.pending, pendingCaseHandler('support'))
      .addCase(sendRequest.rejected, rejectedCaseHandler('support'));
  },
});

export default supportSlice.reducer;

export const sendRequest = createAsyncThunk<void, SupportRequestPayload, IRejectValueThunkConfig>(
  actionPrefix.REQUEST,
  async payload => {
    await sendSupportRequest(payload);
  },
);
